const init = () => {
  const mapButtons = document.querySelectorAll('.js-mapButton');
  const mapImages = document.querySelectorAll('.js-mapImage');

  mapButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      mapButtons.forEach((btn, btnIndex) => {
        if (index === btnIndex) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
      mapImages.forEach((image, imgIndex) => {
        if (index === imgIndex) {
          image.classList.add('is-active');
        } else {
          image.classList.remove('is-active');
        }
      });
    });
  });

  const mapIcon = document.querySelector('.p-map__icon');
  const mapFrame = document.querySelector('.p-map__frame');

  const fadeoutIcon = () => {
    if(window.innerWidth < 992) {
      mapIcon.style.opacity = '0';
      mapIcon.style.visibility = 'hidden';
    }
  }

  mapFrame.addEventListener('click', fadeoutIcon);
  mapFrame.addEventListener('touchstart', fadeoutIcon);
};

export {
    init,
};
